import { MessageCircle } from "lucide-react";
import { useLocale } from "@/context/LocaleContext";

export default function FloatingWhatsApp() {
    const { tr } = useLocale();
    return (
        <a
            href="https://wa.me/351900000000?text=Ol%C3%A1%20NOVIFOOD%2C%20gostaria%20de%20saber%20mais"
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp"
            aria-label="WhatsApp NOVIFOOD"
            className="group hidden lg:inline-flex fixed bottom-5 right-5 z-50 items-center gap-2 rounded-full bg-[#25D366] px-4 h-12 text-white shadow-xl hover:-translate-y-1 transition-all"
        >
            <span className="relative inline-flex">
                <span className="absolute -inset-2 rounded-full bg-[#25D366]/40 animate-ping" />
                <MessageCircle className="h-5 w-5 relative" />
            </span>
            <span className="hidden md:inline text-sm font-semibold">{tr("Fale connosco", "Chat with us")}</span>
        </a>
    );
}
